/* eslint-disable import/prefer-default-export */

export const decodeId = (id, type) =>
  parseInt(decodeURIComponent(id).split(`gid://shopify/${type}/`)[1], 10);

export const getParamFromUrl = (parameterName) => {
  let result = null;
  let tmp = [];
  window.location.search
    .substr(1)
    .split('&')
    .forEach((item) => {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
};

export const getShopUrl = () => {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/storefront/index.js: Could not locate Storefront credentials',
    );
  }

  const technicalData = JSON.parse(technicalDataEl.textContent);
  return technicalData.shopName;
};

export const generateUrl = (handle, type) => {
  if (!handle) return null;
  const shopUrl = getShopUrl();
  return `https://${shopUrl}/${type}/${handle}`;
};

export const isLauraCanada = () => {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/storefront/index.js: Could not locate Storefront credentials',
    );
  }

  const technicalData = JSON.parse(technicalDataEl.textContent);
  return technicalData.shopName?.includes('laura');
};

export const isMelanieLyne = () => {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) {
    // eslint-disable-next-line no-console
    console.error(
      'utils/storefront/index.js: Could not locate Storefront credentials',
    );
  }

  const technicalData = JSON.parse(technicalDataEl.textContent);
  return technicalData.shopName?.includes('melanie');
};

export const isFirstPage = () => {
  const url = new URL(window.location.href);
  const urlParams = new URLSearchParams(url.search);
  const pageParam = urlParams.get('page');
  return !pageParam || pageParam === '1';
};

export const validatePhoneNumber = (v) =>
  v.length === 10 &&
  // eslint-disable-next-line no-useless-escape
  /^[-\s\./0-9]*$/g.test(v);

export const locale = `${Shopify.locale}-${Shopify.country}`;

// Build a list of day of the week names in the user's locale
export const days = [0, 1, 2, 3, 4, 5, 6]
  .map((_, i) =>
    // The first day of 2023 was a Sunday so we use that as a static base
    new Date(`2023-01-0${i + 1}T00:00:00`).toLocaleDateString(locale, {
      weekday: 'long',
    }),
  )
  // French translations are not capitalized for some reason
  .map((day) => day.slice(0, 1).toUpperCase() + day.slice(1));

/**
   * Get the current open/closed status of a store
   */
export const getStoreStatus = (location) => {

  const hours = location && location.hours;

  if (!hours) {
    return {
      openNow: null,
      openToday: null,
      summary: null
    };
  }

  const d = new Date();
  const currentDay = d.getDay();
  const currentMinute = d.getHours() * 60 + d.getMinutes();


  // Find the next day the store will be open
  let nextOpenDay = currentDay < 6 ? currentDay + 1 : 0;
  for (let i = 0; i < 7; i += 1) {
    const dayData = hours && hours[nextOpenDay];
    if (dayData && dayData.isOpen) {
      break;
    } else {
      nextOpenDay = nextOpenDay < 6 ? nextOpenDay + 1 : 0;
    }
  }

  const nextOpenDayOfWeek = days[nextOpenDay];
  const nextOpenCloseTime = hours && hours[nextOpenDay]?.displayHours?.split(' - ');
  const nextOpenTime =
    nextOpenCloseTime &&
    nextOpenCloseTime[0] &&
    nextOpenCloseTime[0].trim();

  const todaysHours = hours && hours[currentDay];
  const openCloseHours = todaysHours?.displayHours?.split(' - ');
  const [open, close] = openCloseHours || [];

  if (!open || !close) {
    return {
      openNow: null,
      openToday: null,
      summary: null
    }
  }

  // Not open today, show when store next opens
  if (
    !todaysHours ||
    !todaysHours.isOpen ||
    currentMinute >= todaysHours.closeMinute
  ) {
    return {
      openNow: false,
      openToday: todaysHours?.isOpen,
      summary: nextOpenDayOfWeek && nextOpenTime ?
        (window.TMW.Strings.storeLocator.closedNow
          .replace('{{day}}', nextOpenDayOfWeek)
          .replace('{{time}}', nextOpenTime)
        ) : null,
    }
  }

  // Store is open today, but not yet
  if (currentMinute < todaysHours.openMinute) {
    return {
      openNow: false,
      openToday: todaysHours.isOpen,
      summary: open ? (window.TMW.Strings.storeLocator.openAt.replace(
        '{{time}}',
        open,
      )) : window.TMW.Strings.storeLocator.closed,
    };
  }
  // Store is open now
  return {
    openNow: true,
    openToday: todaysHours.isOpen,
    summary: close ? (window.TMW.Strings.storeLocator.openNow.replace(
      '{{time}}',
      close,
    )) : window.TMW.Strings.storeLocator.open,
  };
}


export const validateEmail = (email) =>
  // eslint-disable-next-line no-useless-escape, max-len
  /^[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(
    email,
  );

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

export const setCookie = (name, value, day = 1) => {
  const expire = new Date(Date.now() + day * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expire}; path=/`;
};

export const sortProductFits = (fits) => {
  if (!fits) return [];
  return fits.sort((a, b) => {
    const order = { Laura: 0, Plus: 1, Petites: 2 };
    return order[a] - order[b];
  });
};

export const sortProductSizes = (sizes) => {
  let sortedSizes = [];
  const windowSizesOrder = window.TMW.Strings.product.sizesOrder.split(', ');
  windowSizesOrder.map((size) => size.trim().toLowerCase());

  // Sort sizes array based on the sort order defined in windowSizesOrder
  sortedSizes = sizes.sort((a, b) => {
    const indexA = windowSizesOrder.indexOf(a.trim().toLowerCase());
    const indexB = windowSizesOrder.indexOf(b.trim().toLowerCase());
    return indexA - indexB;
  });

  return sortedSizes;
};

export const getProductLabel = (tags = []) => {
  if (tags.includes('final-sale::true')) {
    return window.TMW.Strings.product.finalSale;
  }
  if (tags.includes('exchange-only::true')) {
    return window.TMW.Strings.product.exchangeOnly;
  }
  return null;
};

export const getProductFit = (product = {}) =>
  product.variants?.[0].selectedOptions?.find(
    (option) =>
      option.name.trim().toLowerCase() ===
      window.TMW.Strings.product.options.fit,
  )?.value || null;

export const getProductColor = (product = {}) =>
  getVariantColor(product.variants?.[0]);

export const getVariantColor = (variant = {}) =>
  variant.selectedOptions?.find(
    (option) =>
      option.name.trim().toLowerCase() ===
      window.TMW.Strings.product.options.color,
  )?.value || null;

export const waitForElm = (selector, root) =>
  new Promise((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector));
      return;
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });
    observer.observe(root || document.body, {
      childList: true,
      subtree: true,
    });
  });

export const isProductAccessory = (product) => {
  const csku = product.groupId.replace('csku::', '');
  // as per documentation in LS-29 description
  return csku.startsWith('70');
}

export const capitalizeFirstLetter = (val) => {
  if (!val) {
    return '';
  }

  const first = String(val).charAt(0).toUpperCase();
  const rest = String(val).slice(1);
  return first + rest;
}

export const isFinalSale = (tags = []) => tags.includes('final-sale::true');

export const isStyleNumberIncluded = (styleNumber, codes) => 
  codes.some(code => styleNumber.includes(code));

export const ProductPolicy = 
(currentProduct, currentVariant, styleNumber, inlineDiscount) => {
  const policyData = {
    "enabled" : false,
    "policynotes": "",
    "policyPopup": "",
    "currentVariantId": "null"
  };

  const data =
  window.getDiscountData(currentProduct, inlineDiscount, currentVariant);

  const currentPolicy =  readJsonData('product-policy-json-data', "productPolicies");

  if (!currentPolicy || !currentPolicy.enabled) {
    return policyData;
  }
  if (currentVariant) {
    policyData.currentVariantId = currentVariant.id;
  }

  const hasDiscount = Boolean(data.discountPercentage);
  const finalSale = isFinalSale(currentProduct.tags || []);
  if (hasDiscount && finalSale) {
    return policyData;
  }

  let inputSkus = currentPolicy.skus;
  inputSkus = inputSkus.replace(/'/g, '"');
  const skusArray = JSON.parse(inputSkus);
  if (!isStyleNumberIncluded(styleNumber, skusArray)) {
    return policyData;
  }

  policyData.enabled = true;
  policyData.policynotes = currentPolicy.notes;
  policyData.policyPopup = currentPolicy.popup_id;
  
  return policyData;
}

export const ProductReturnPolicy =
(currentProduct, styleNumber, currentVariant = "none") => {
  const returnPolicyData = {
    "enabled" : false,
    "policynotes": "",
    "policyLabel": ""
  };

  if (!currentProduct || !currentProduct.tags) {
    return returnPolicyData;
  }

  const currentPolicy =  readJsonData('product-return-policy-json-data', "returnPolicies");

  if(currentPolicy == null){
    return returnPolicyData;
  }

  const currentTags = currentProduct.tags;
  const onSale = currentTags.includes("on_sale::true");
  const finalSale = currentTags.includes("final-sale::true");
    if(onSale && !finalSale){
    returnPolicyData.enabled = true;
    returnPolicyData.policynotes = currentPolicy.notes;
    returnPolicyData.policyLabel = locale.includes("fr") 
    ? currentPolicy.giftCardLabelEn 
    : currentPolicy.giftCardLabelFr;
    if(currentVariant !== "none"){
      let inputSkus = currentPolicy.skus;
      inputSkus = inputSkus.replace(/'/g, '"');
      const skusArray = JSON.parse(inputSkus);
      if (isStyleNumberIncluded(styleNumber, skusArray)) {
        returnPolicyData.enabled = false;
      }
    }
  }

  return returnPolicyData;

}

export const setProductCartLabel = (tags = []) => { 

  const currentPolicy =  readJsonData('product-return-policy-json-data', "returnPolicies");

  if (!currentPolicy) {
    return null;
  }

  if (tags.includes('final-sale::true')) {
    return `${currentPolicy.finalSaleLabelEn},
    ${currentPolicy.finalSaleLabelFr}`;
  }
  if (tags.includes('exchange-only::true')) {
    return `${currentPolicy.exchangeLabelEn},
    ${currentPolicy.exchangeLabelFr}`;
  }

  const onSale = tags.includes("on_sale::true");
  const finalSale = tags.includes("final-sale::true");
  const cocktailDresses = tags.includes("class::Cocktail Dresses");
  const eveningDresses = tags.includes("class::Evening Dresses & Jumpsuits");

  if (cocktailDresses || eveningDresses) {
    if(!finalSale){
      return `${currentPolicy.giftCardLabelEn},
      ${currentPolicy.giftCardLabelFr}`;
    }    
  }

  if (onSale && !finalSale) {    
    return `${currentPolicy.giftCardLabelEn},
    ${currentPolicy.giftCardLabelFr}`;
  }

  return null;
};

export const readJsonData = (id, propertyName) => {
  const el = document.getElementById(id);
  if (!el) {
    // eslint-disable-next-line no-console
    console.warn(`JSON element ${id} not found`);
    return null;
  }

  const jsonData = JSON.parse(el.textContent);

  const result = 
  jsonData[propertyName] && jsonData[propertyName].length > 0
   ? jsonData[propertyName] : null;

  if(result == null){
    // eslint-disable-next-line no-console
    console.warn(`${propertyName} property not found in JSON element ${id}`);
    return null;
  } 

  return result[0];
}